module.exports = require("@swa-ui/core/src/AnimateSvg/AnimateSvg.module.scss");